import { Component, ChangeDetectionStrategy, Input, input } from '@angular/core';
import { Observable } from 'rxjs';
import { SocialChannel } from '../../models';
import { IconComponent } from '@teamfoster/sdk/icon';
import { icons } from 'src/assets/dist/svg/icons';
import { url } from 'node:inspector';
import { getSocialIconForUrl } from '../../utils/social-util';
import { SocialIconPipe } from '../../pipes/social-icon.pipe';

@Component({
  selector: 'app-social-channel-buttons',
  templateUrl: './social-channel-buttons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./social-channel-buttons.component.scss'],
  imports: [IconComponent, SocialIconPipe],
})
export class SocialChannelButtonsComponent {
  channels = input<SocialChannel[]>([]);
  title = input<string | null>();
  buttonSize = input<string>('sm');
}
